export const getEmptyConditionsCaption = (isConfigurable: boolean | undefined) =>
  `${isConfigurable ? "Conditions are not set..." : "No conditions"}`;
